<template>
    <div class="cusModal" v-if="showtable">
        <div class="cusModalCont">
            <div class="cusModalTitle blackBack">{{ title }}
                <div class="eportBtn">
                    <div @click="   exportReport('pdf')" style="cursor:pointer;">PDF</div>
                    <div @click="exportReport('excel')" style="cursor:pointer;">Excel</div>
                    <div @click="exportReport('print')" style="cursor:pointer;">{{lang.print}}</div>
                </div>
                <div class="cusModalClose" @click="closeTable()">{{ lang.close }}</div>
            </div>
            <div class="cusModalBody">
                <v-simple-table class="mt-1" :style="`padding-inline:40px;direction: ${lang.dir};`">
                    <thead>
                        <tr>
                            <th class="backBlack text-center">{{lang.date}}</th>
                            <th class="backBlack text-center">{{lang.invoiceno}}</th>
                            <th class="backBlack text-center">{{lang.vendor_name}}</th>
                            <th class="backBlack text-center">{{lang.vat_number}}</th>
                            <th class="backBlack text-center">{{lang.total}}</th>
                            <th class="backBlack text-center">{{lang.vat}}</th>
                            <th class="backBlack text-center">{{lang.ftotal}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in tbrows" :key="index">
                            <td class="text-center">{{item.bill_date}}</td>
                            <td class="text-center">{{item.bill_number}}</td>
                            <td class="text-center">{{item.vendor}}</td>
                            <td class="text-center">{{item.vatid}}</td>
                            <td class="text-center">{{item.total}}</td>
                            <td class="text-center">{{item.vat}}</td>
                            <td class="text-center">{{item.ftotal}}</td>
                        </tr>
                    </tbody>

                </v-simple-table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default{
    data() {
        return {
            title: 'المصروفات',
            showtable: false,
            tbrows: [],
            search: {
                sdate: '',
                edate: '',
            }
        }
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        totals: function(){
            let t = {
                total: 0, qty: 0, current: 0
            }
            for(let i=0;i<this.tbrows.length;i++){
                t.qty = parseFloat(t.qty) + parseFloat(this.tbrows[i].qtty)
                t.total = parseFloat(t.total) + parseFloat(this.tbrows[i].total)
                t.current = parseFloat(t.current) + parseFloat(this.tbrows[i].current)
            }
            return t;
        },
    },
    methods: {
        exportReport(type){
            const post = new FormData();
            post.append('type','exportDashboard');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[options]',JSON.stringify({
                title: this.title,
                search: this.search,
            }));
            post.append('data[exportType]',type);
            post.append('data[module]','purchase');

            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                if(type == 'pdf'){
                    window.open(this.origin + '/api/export-print.php?export=' + res.results.data.newID,'_blank')
                }
                else if(type == 'excel')
                {
                    window.open(this.origin + '/api/export-print.php?excel&export=' + res.results.data.newID,'_blank')
                }else{
                    let pdfFrame = document.body.appendChild(document.createElement('iframe'));
                    pdfFrame.style.display = 'none';
                    pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
                    pdfFrame.src = this.origin + '/api/export-print.php?export=' + res.results.data.newID;
                    // window.print()
                }
            })

        },
        closeTable(){
            this.title = 'اوامر التشغيل',
            this.showtable = false;
            this.tbrows = []
            this.search = {
                sdate: '',
                edate: '',
            }
        },
        getReport(option) {
            this.title = option.name
            this.showtable = true;
            const post = new FormData();
            post.append('type','getBillDashboard');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[options]',JSON.stringify(option));

            this.tbrows = [];
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
               this.tbrows = response.data.results.data;
            })
        }
    },
    created() {
        //
    },
}
</script>
<style scoped>
.cusModal{
    position: fixed;
    background:#0000001a;
    top:0;
    left:0;
    bottom:0;
    right:0;
    z-index: 20000000;
    display:flex;
    justify-content: center;
    justify-items: center;
    align-items: center;;
}
.cusModalCont{
    position:relative;
    width:70%;
    height: 70vh;
    border:1px solid #bbb;
    background:#fff;
    box-shadow: 0px 1px 1px 1px #0000001a;
    border-radius: 5px;
}
.eportBtn{
    position: absolute;
    top:2px;
    left:60px;
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
    display:flex;
    justify-content: space-between;
    justify-items: center;
    align-items: center;
}
.eportBtn div{
    padding:2px 5px;
    width:80px;
    font-size:.8rem;
    background:blue;
    margin-inline-start:5px;
    color:#fff;
    border-radius: 3px;
}
.cusModalClose{
    position: absolute;
    top:2px;
    left:10px;
    background:red;
    color:#fff;
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
}
.cusModalCloseL:hover{
    background: darkred;
}
.cusModalTitle{
    padding:5px;
    text-align:center;
    border-color: #bbb !important;
    border-bottom-color: #000 !important;
}
.cusModalBody{
    overflow: auto;
    height:calc(70vh - 50px);
    max-height:calc(70vh - 50px);
    padding:5px;
}
</style>